import { ReactNode } from "react";

export const TestScreenPath = `/tst-screen`;
export function TestScreen(): ReactNode {
  throw new Error(`TestScreen error`);
}
